<template>
  <div>
    <header class="sui-navbar" style="min-width: 790px;margin-bottom: 0px;">
      <div>
        <ul class="next-navigation next-navigation-horizontal next-navigation-filling next-navigation-root">
          <li class="navigation-logo-zone" style="padding: 0;width: 148px">
            <div style="text-align: center;line-height: 52px;">
              <i class="next-icon next-icon-print next-icon-medium"></i><span style="margin-left: 8px; font-size: 16px;">飞牛打单</span>
            </div>
          </li>
          <li class="next-navigation-item next-navigation-item-align-center" v-for="(menu, index) in getTopMenus()" v-if="menu.subMenus.length > 0" v-bind:class="{'next-navigation-item-selected' : index === activeIndex.menuIndex }">
            <div class="next-navigation-item-content" @click="()=>changeMainMenu(index)">
              <div class="next-navigation-item-content-inner" style="padding: 0 10px;"><span class="next-navigation-item-text">{{menu.name}}</span>
                <i class="next-icon next-icon-medium next-navigation-item-icon next-navigation-item-leaf-icon" v-bind:class="{'next-icon-arrow-down' : menu.subMenus.length > 1}"></i>
                <span v-if="index != getTopMenus().length - 1">|</span>
              </div>
            </div>
            <div v-if="menu.subMenus.length > 1" class="next-navigation-item-children-menu">
              <div tabindex="0" class="next-menu ver header-nav-menu">
                <ul class="next-menu-content" v-for="subMenu in menu.subMenus">
                  <li tabindex="-1" role="menuitem" class="next-menu-item" v-bind:class="{active: subMenu.url == activeIndex.path}" @click="()=>changePage(subMenu.url)">
                    {{subMenu.name}}
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li v-if="printOrderVersion =='v1'" style="float: right;font-size: 12px;" class="next-navigation-item next-navigation-item-align-center">
            <div class="next-navigation-item-content">
              <div class="next-navigation-item-content-inner"><i
                style="vertical-align: 0px;" class="next-icon next-icon-account next-icon-medium next-navigation-item-icon next-navigation-item-custom-icon"></i><span
                class="next-navigation-item-text">{{selectedShopTitle ? selectedShopTitle : (shopList && shopList.length > 0) ? shopList[0].shopTitle : '店铺切换'}}</span><i
                class="next-icon next-icon-arrow-down next-icon-medium next-navigation-item-icon next-navigation-item-leaf-icon"></i>
              </div>
            </div>
            <div class="next-navigation-item-children-menu" style="max-height: 450px;overflow-y: auto">
              <div tabindex="0" class="next-menu ver">
                <ul class="next-menu-content">
                  <li tabindex="-1" role="menuitem" class="next-menu-item" v-for="(shop, index) in shopList" v-bind:class="{selected: selectedLoginId ? (shop.ownerId === selectedLoginId) : index === 0}" @click="changeShop(shop.ownerId)">{{shop.shopTitle}}</li>
                  <li tabindex="-1" role="menuitem" class="next-menu-item" :onclick="`window.open('#/setting/bindSubShop')`"><span class="add-shop-icon"><i class="el-icon-plus mr-5"></i>关联店铺</span></li>
                  <li tabindex="-1" role="menuitem" class="next-menu-item" :onclick="`window.location='${baseURL}pdd/auth/logout'`"><span class="add-shop-icon"><i class="el-icon-switch-button mr-5"></i>退出登录</span></li>
                </ul>
              </div>
            </div>
          </li>
          <li class="navigation-toolbar">
            <ul>
              <li style="cursor: default;margin-left: 8px;">
                <el-button :plain="true" @click="settingSubShop"><i style="font-size: 16px;" class="el-icon-s-shop"></i><span style="font-size: 14px;">多店铺设置</span></el-button>
              </li>
              <li class="next-navigation-item next-navigation-item-align-center">
                <div class="next-navigation-item-content">
                  <div class="next-navigation-item-content-inner">
                    <i class="next-icon next-icon-atm next-icon-small" style="margin-right: 5px;"></i><span>帮助</span>
                  </div>
                </div>
                <div class="next-navigation-item-children-menu">
                  <div tabindex="0" class="next-menu ver header-nav-menu">
                    <ul class="next-menu-content">
                      <li tabindex="-1" role="menuitem" class="next-menu-item" :onclick="`window.open('https://opds5uhg3c.apifox.cn')`">帮助中心</li>
                      <li tabindex="-1" role="menuitem" class="next-menu-item" @click="openContactInfo">联系客服</li>
                      <li tabindex="-1" role="menuitem" class="next-menu-item" :onclick="`window.location='${baseURL}pdd/auth/redirectAuth'`">重新授权</li>
                      <li tabindex="-1" role="menuitem" class="next-menu-item" :onclick="`window.location='${baseURL}/createShortcut'`">快捷方式</li>
                    </ul>
                  </div>
                </div>
              </li>
              <li style="cursor: default;margin-left: 8px;">
                <span>剩余 {{remainDeadline}} 天</span>
              </li>
              <li style="margin-left: 16px;">
								<span>
                  <el-popover
                    placement="bottom-start"
                    width="200"
                    trigger="hover"
                  >
                    <div>
                      <div style="font-size: 12px;">登录店铺：{{ loginShopInfo.shopTitle }}</div>
                      <div style="font-size: 12px;">到期时间：{{ DateUtils.formatDateTime(new Date(loginShopInfo.expiresTime))}}</div>
                      <div style="font-size: 12px;">订购版本：{{ loginShopInfo.version =='v2' ? '高级版':'试用版' }}</div>
                    </div>
										<a class="btn-buy" slot="reference" href="https://fuwu.pinduoduo.com/service-market/service-detail?detailId=22856" target="_blank">{{'续费'}}</a>
                  </el-popover>
                </span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </header>
    <div class="ui-main-content">
      <div class="left-menu"  v-bind:class="{'narrow' : !leftMenuExpand}">
        <div class="left-menu-content" v-if="false">
          <div class="menu-top" @click="changeLeftMenuExpand">
            <i class="iconfont"></i>
          </div>
          <div v-for="(menu, menuIndex) in menus" v-bind:class="{'hide' : menuIndex !== activeIndex.menuIndex }">
            <div class="sub-menus" v-for="(menu, subMenuIndex) in menu.subMenus" v-bind:class="{ 'no-child': !menu.subMenus || menu.subMenus.length == 0, 'selected' : subMenuIndex === activeIndex.subMenuIndex, 'close' : subMenuIsClose(menuIndex, subMenuIndex) }">
              <div class="icon-wrap">
                <i :class="'iconfont icon-small fc-white icon ' + menu.icon"></i>
              </div>
              <ul class="sub-menu">
                <li class="title title-menus" @click="()=>{changeSubMenuOpenState(menuIndex, subMenuIndex)}">
                  <span class="title-desc fadeIn">
                    {{menu.name}}<i class="iconfont icon-xs fc-description icon-arrow" v-if="menu.subMenus && menu.subMenus.length > 0"></i>
                  </span>
                </li>
                <li  v-for="(menu, pageIndex) in (menu.subMenus ? menu.subMenus : [])" class="child" v-bind:class="{'selected' : (pageIndex === activeIndex.pageIndex && subMenuIndex === activeIndex.subMenuIndex) }" @click="()=>changePage(menu.url)">
                  {{menu.name}}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="right-content" v-bind:class="{'full' : !leftMenuExpand}">
        <router-view/>
      </div>
    </div>
    <el-dialog :visible.sync="noticeDialogVisible" width="640px" height="302px">
      <div style="text-align:center;">
        <el-carousel height="402px">
          <el-carousel-item v-for="noticeMessage in noticeList" :key="noticeMessage.id">
            <div style="margin-top: 12px;color: red;font-size: 20px;">
              <span>{{noticeMessage ? noticeMessage.noticeTitle :''}}</span>
            </div>
            <div style="margin-top: 8px;background:#dcdcdb;border-radius: 6px;">
              <div style="padding: 12px;font-size: 12px;text-align: left;" v-html="(noticeMessage ? noticeMessage.noticeContent :'')">
              </div>
            </div>
            <div style="margin-top: 32px;margin-bottom:32px;color: #000000;font-size: 20px;">
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import COMMON_API from './utils/api/v2/common/index';
  import {DateUtils} from './utils'
  export default {
    name: 'App',
    data() {
      const menus = [
        {
          name: '打单发货',
          subMenus: [
            {
              name: '打印发货',
              icon: 'icon-shopping',
              subMenus: [
                {
                  name: '订单打印',
                  url: '/print',
                },
                // {
                //   name: '跨境全托管发货单',
                //   url: '/print/fulfillment',
                // }
              ],
            }
          ]
        },
        {
          name: '手工订单',
          subMenus: [
            {
              name: '手工订单',
              url: '/print/custom',
            }
          ]
        },
        {
          name: '面单记录',
          subMenus: [
            {
              name: '面单查询/回收',
              url: '/print/waybillCodeList',
            }, {
              name: '分享面单',
              url: '/print/waybillAccountList',
            },
            , {
              name: '面单统计',
              url: '/waybill/expressWaybillList',
            },
            // {
            //   name: '网点查询',
            //   url: '/branch/search',
            // }
          ]
        },
        {
          name: '打印日志',
          subMenus: [
            {
              name: '打单日志',
              url: '/print/order/log',
            },
            {
              name: '发货单日志',
              url: '/print/invoice/log',
            },
            {
              name: '发货日志',
              url: '/send/order/log',
            }
          ]
        },
        {
          name: '设置',
          subMenus: [
            {
              name: '基础设置',
              url: '/setting/setting',
            },
            // {
            //   name: '快递单模版',
            //   url: '/template/express/list',
            // }, {
            //   name: '发货单模版',
            //   url: '/template/invoice/list',
            // }, {
            //   name: '拣货单模版',
            //   url: '/template/pick/list',
            // },
            // {
            //   name: '发货地址',
            //   url: '/setting/senderAddress',
            // }
          ]
        },
        {
          name: '更多功能',
          subMenus: [
            // {
            //   name: '多店铺关联',
            //   url: '/setting/bindSubShop',
            // },
            {
              name: '订单查询',
              icon: 'icon-zoom',
	            url: '/service/orderList',
            },
            {
              name: '宝贝管理',
              icon: 'icon-item',
              url: '/goods/list',
            }, {
              name: '导入发货',
              url: '/print/ExportSend',
            }, {
              name: '扫码发货',
              url: '/print/scanOutbound',
            }
          ]
        },
      ];
      let leftMenuExpand = window.localStorage.getItem('leftMenuExpand');
      if (leftMenuExpand === 'false') {
        leftMenuExpand = false;
      } else {
        leftMenuExpand = true;
      }
      const subMenuOpenState = {}
      return {
        DateUtils,
        menus,
        activeIndex: {
          menuIndex: null,
          subMenuIndex: null,
          pageIndex: null,
        },
        leftMenuExpand:false,
        subMenuOpenState,
        baseURL: process.env.BASE_URL,
        remainDeadline: null,
        version: '',
        shopList: [],
        selectedLoginId: null,
        selectedShopTitle: null,
        noticeDialogVisible:false,
        noticeList:[],
        loginShopInfo:'',
        printOrderVersion:'v2',
      }
    },
    created() {
      this.setActiveMenu();
    },
    watch: {
      $route: {
        handler: function(val, oldVal){
            this.setActiveMenu();
        },
        // 深度观察监听
        deep: true
      }
    },
    mounted() {
      let printOrderVersion = window.localStorage.getItem("print_order_version");
      if(printOrderVersion){
        this.printOrderVersion = printOrderVersion;
      }else{
        this.printOrderVersion = "v2";
      }
      COMMON_API.getPddShopByOwnerId({}).then(result => {
        if (result.isSuccess) {
          const shop = result.data;
          if (shop) {
            this.loginShopInfo = shop;
            this.remainDeadline = shop.remainDeadline;
            this.version = shop.version;
	          window.localStorage.setItem('loginId', shop.ownerId);
          }
        }
      });
      COMMON_API.getPddShopList().then(result => {
        if (result.isSuccess) {
          const data = result.data;
          this.shopList = data.shopList;
          const selectedLoginId = data.selectedLoginId;
          if (selectedLoginId) {
            this.shopList.map(shop => {
              if (shop.ownerId === selectedLoginId) {
                this.selectedShopTitle = shop.shopTitle;
                this.selectedLoginId = shop.ownerId;
              }
            });
          }
          if (!this.selectedLoginId) {
            this.selectedShopTitle = this.shopList[0].shopTitle;
            this.selectedLoginId = this.shopList[0].ownerId;
          }
          window.localStorage.setItem('shopList', JSON.stringify(this.shopList));
          window.localStorage.setItem('selectedLoginId', this.selectedLoginId ? this.selectedLoginId : '');
        }
        this.getNoticeByType();
      });
    },
    methods: {
      getTopMenus() {
        const topMenus = [];
        this.menus.map(menu => {
          const subMenus = [];
          if (menu.showOnHeader !== false) {
            if (menu.subMenus && menu.subMenus.length >0) {
              menu.subMenus.map(menu => {
                if (menu.showOnHeader !== false) {
                  if (menu.subMenus && menu.subMenus.length > 0) {
                    menu.subMenus.map(menu => {
                      if (menu.showOnHeader !== false) {
                        subMenus.push({
                          name: menu.name,
                          url: menu.url,
                        });
                      }
                    });
                  } else {
                    subMenus.push({
                      name: menu.name,
                      url: menu.url,
                    });
                  }
                }
              });
            }
          }
          topMenus.push({
            name: menu.name,
            subMenus
          });
        });
        return topMenus;
      },
      setActiveMenu() {
        let path = this.$route.path;
        let printOrderVersion = window.localStorage.getItem("print_order_version");
        if (path) {
          path = path.replace('#', '');
          if (path == '/') {
            path = '/print'
          }else if(path == '/print/orderOld'){
            path = '/print'
          }else if(path.startsWith('/template/pick/addPickTemplate')){
            let menuName = this.$route.query.menuName;
            path = '/template/pick/list'
            if(menuName){
              path= '/'+ menuName;
            }
          }else if(path.startsWith('/template/invoice/addInvoiceTemplate')){
            let menuName = this.$route.query.menuName;
            path = '/template/invoice/list'
            if(menuName){
              path= '/'+ menuName;
            }
          }
        }
        this.menus.map((menu, menuIndex) => {
          if (menu.subMenus && menu.subMenus.length > 0) {
            menu.subMenus.map((menu, subMenuIndex) => {
              if (menu.subMenus && menu.subMenus.length > 0) {
                menu.subMenus.map((menu, pageIndex) => {
                  if (menu.url == path) {
                    this.activeIndex = {menuIndex, subMenuIndex, pageIndex, path};
                  }
                });
              } else if (menu.url == path) {
                this.activeIndex = {menuIndex, subMenuIndex, pageIndex: null, path};
              }
            });
          } else if (menu.url == path) {
            this.activeIndex = {menuIndex, subMenuIndex: null, pageIndex: null, path};
          }
        });
      },
      changePage(url) {
        if (url) {
          let printOrderVersion = window.localStorage.getItem("print_order_version");
          if(url == '/print' || url == '/'){
            if(printOrderVersion == 'v1'){
              url = '/print/orderOld'
            }
          }
          this.$router.push(url);
          this.setActiveMenu();
        }
      },
      changeMainMenu(index) {
        const menu = this.menus[index];
        let url;
        // 找到子菜单的第一个url
        if (menu.url) {
          url = menu.url;
        } else if (menu.subMenus && menu.subMenus.length > 0) {
          const subMenu = menu.subMenus[0];
          if (subMenu.url) {
            url = subMenu.url;
          } else if (subMenu.subMenus && subMenu.subMenus.length > 0) {
            const page = subMenu.subMenus[0];
            if (page.url) {
              url = page.url;
            }
          }
        }
        this.changePage(url);
      },
      changeLeftMenuExpand() {
        if (this.leftMenuExpand) {
          window.localStorage.setItem('leftMenuExpand', "false");
          this.leftMenuExpand = false;
        } else {
          window.localStorage.setItem('leftMenuExpand', "true");
          this.leftMenuExpand = true;
        }
      },
      changeSubMenuOpenState(menuIndex, subMenuIndex) {
        const indexKey = 'state_' + menuIndex + '_' + subMenuIndex;
        if (this.subMenuOpenState[indexKey] == 'open') {
          this.$set(this.subMenuOpenState, indexKey, 'close');
        } else {
          this.$set(this.subMenuOpenState, indexKey, 'open');
        }
      },
      subMenuIsClose(menuIndex, subMenuIndex) {
        const indexKey = 'state_' + menuIndex + '_' + subMenuIndex;
        if (typeof this.subMenuOpenState[indexKey] == 'undefined') {
          this.$set(this.subMenuOpenState, indexKey, subMenuIndex === this.activeIndex.subMenuIndex ? 'open' : 'close');
        }
        return this.subMenuOpenState[indexKey] == 'close';
      },
      changeShop(ownerId) {
        COMMON_API.changeShop(ownerId).then(result => {
          if (result.isSuccess) {
            document.location.reload();
          }
        });
      },
      getNoticeByType(){
        let _this = this;
        COMMON_API.getNoticeByType({noticeType:2}).then(result =>{
          if(result.isSuccess){
            let data = result.data;
            if(data && data.length >0){
              _this.noticeList = data;
              _this.showNotify(data[0]);
            }
          }
        })
      },
      showNotify(noticeMessage){
        let noticeId = noticeMessage.noticeType;
        let date = DateUtils.formatDate(new Date());
        let key = "showNotify_"+date+"_"+noticeId;
        let showNotify = window.localStorage.getItem(key);
        //showNotify = false;
        if(!showNotify){
          window.localStorage.setItem(key, true);
          setTimeout(() => {
            this.noticeDialogVisible = true;
          },1000);
        }
        //this.noticeDialogVisible = true;
      },
      openContactInfo() {
        this.$notify({
          title: '联系方式',
          dangerouslyUseHTMLString: true,
          type: 'success',
          customClass:'notify-success',
          message: '<span><strong>微信:</strong>&emsp;chqyljy</span><br>' +
            '<span><strong>电话:</strong>&emsp;18030533510</span>'
        });
      },
      settingSubShop(){
        this.$router.push("/setting/setting?type=multiple_store_setting")
      },
    }
  }
</script>

<style>
.navigation-toolbar {
  height: 50px;
}
.navigation-toolbar>ul>li {
  height: 50px;
  line-height: 50px;
}
.navigation-toolbar .next-navigation-item-align-center {
  margin-left: 0px;
}
.navigation-toolbar .next-navigation-item-align-center:hover {
  background: none;
}
.navigation-toolbar .next-navigation-item-content-inner {
  padding: 0 8px;
}
.next-navigation-filling {
  background-image: linear-gradient(90deg, #04a9fe 0%, #3286e8 100%);
}

.next-navigation-filling .next-navigation-item {
  background-color: rgba(255, 255, 255, 0);
}

.next-navigation-filling .next-navigation-item:hover {
  background-color: rgba(50,134,232, 0.4);
}

.next-navigation-filling .next-navigation-item-selected .next-navigation-item-content {
  color: #fff;
  background-color: rgba(50,134,232, 0.5);
}

.next-menu .next-menu-item.active {
  background: #eee;
}

.btn-buy,.btn-upgrade {
  border: 1px solid white;
  border-radius: 12px;
  width: 52px;
  padding: 2px 12px;
  font-size: 13px !important;
}

.btn-buy {
  background-color: transparent;
  color: #fff !important;
}

.btn-buy:hover {
  background-color: white;
  color: #3089dc !important;
}

.btn-upgrade {
  background-color: white;
  color: #3089dc;
}

.btn-upgrade:hover {
  background-color: transparent;
  color: #fff;
}
.notify-success{
  background: #fff5e6 !important;
  border-radius: 0.5rem !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue